import './components.css';

export function Spinner({ label }: { label?: string }) {
  return (
    <span role="status" aria-live="polite" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span className="spinner" aria-hidden="true" />
      <span className="visually-hidden">{label ?? 'Loading'}</span>
    </span>
  );
}
